module.exports = __webpack_public_path__ + "static/media/inox.b4c36d5a.jpg";